import {ScrollTrigger} from "../LibrariesImport";

// Sommaire accroché de la page de détail d'une solution : met en évidence l'item de la section
// traversée. Le défilement au clic reste natif (ancres) — Lenis les intercepte avec son propre
// offset, et le scroll-padding-top de <html> prend le relais quand Lenis est désactivé.
export default class SolutionNav {
	constructor() {
		document.querySelectorAll("[data-solution-nav]").forEach((nav) => {
			const links = [...nav.querySelectorAll("[data-solution-nav-link]")];
			if (!links.length) return;

			const setCurrent = (link) => {
				links.forEach((item) => item.classList.toggle("is-current", item === link));
			};

			// Avant d'atteindre la première section, c'est elle que le sommaire annonce
			setCurrent(links[0]);

			links.forEach((link) => {
				const section = document.getElementById(decodeURIComponent(link.hash.slice(1)));
				if (!section) return;

				// La section active est celle qui croise le tiers haut du viewport : le même
				// repère que l'offset des ancres, pour qu'un clic active bien la section visée.
				// onToggle ne remet jamais à zéro en sortie : entre deux sections (marge du
				// répéteur), la dernière traversée reste mise en évidence.
				ScrollTrigger.create({
					trigger: section,
					start: "top 35%",
					end: "bottom 35%",
					onToggle: (self) => {
						if (self.isActive) setCurrent(link);
					}
				});
			});
		});
	}
}
